module.exports = __webpack_public_path__ + "img/zhiyelogoendeee.724efd60.svg";